export const historyData = {
    intro:'As we celebrate our establishment, we are excited about the future and the path we are charting. Our roadmap is centered on continuous growth, innovation, and delivering unparalleled value to our clients. In the coming years, we aim to:',
    content:[
    {
        id:1,
        title: 'Expand Our Service Offerings:',
        desc: 'We will continue to enhance and diversify our range of services, ensuring we meet the ever-changing needs of the business world. This includes advancing our HR software solutions and introducing new advisory services to address emerging trends and challenges.',
    },
    {
        id:2,
        title: 'Strengthen Client Relationships',
        desc: 'Our clients are at the heart of everything we do. We are committed to deepening our partnerships by providing personalized, high-quality services that drive their success.',
    },
    {
        id:3,
        title: 'Invest in Technology:',
        desc: 'Leveraging cutting-edge technology is vital for our future growth. We plan to invest in innovative HR tech solutions that streamline processes, improve efficiency, and offer our clients the best tools for managing their workforce.',
    },
    {
        id:4,
        title: 'Expand Geographically:',
        desc: 'While we have a strong presence locally, our goal is to expand our footprint both nationally and internationally. We aspire to bring our expertise and services to a broader audience, helping businesses around the globe thrive.',

    },
    {
        id:5,
        title:'Promote Sustainable Practices:',
        desc:'Sustainability is integral to our business philosophy. We will continue to adopt and promote sustainable practices within our operations and encourage our clients to do the same, ensuring a positive impact on the environment and society.'
    }
]};
